export { getNavigateToTeamsApp } from '../src/getNavigateToTeamsApp.ts';
